(function ($) {
  var mobileMenu = {
    hamburgerClick: function () {
      $('.js-mobileToggle').toggleClass('headerMenu__mobileToggle--isActive');
      $('.js-mobileLinks').toggleClass('headerMenu__mobileLinks--isActive').slideToggle();
    },

    windowResize: function (el) {
      if ($(el).width() > 1024) {
        $('.js-mobileToggle').removeClass('headerMenu__mobileToggle--isActive');
        $('.js-mobileLinks').removeClass('headerMenu__mobileLinks--isActive');
      }
    },

    init: function () {
      var self = this;

      $('.js-mobileToggle').click(function () {
        self.hamburgerClick();
      });

      $(window).on('resize', function () {
        self.windowResize($(this));
      });
    }
  };

  return mobileMenu.init();
}(jQuery));



// WEBPACK FOOTER //
// ./wp-content/themes/figpress-child/src/js/modules/MobileMenu.js